import { render } from "./CIS-ResourceHeading.vue?vue&type=template&id=00baf086"
import script from "./CIS-ResourceHeading.vue?vue&type=script&lang=js"
export * from "./CIS-ResourceHeading.vue?vue&type=script&lang=js"

import "./CIS-ResourceHeading.vue?vue&type=style&index=0&id=00baf086&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__